import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const Instruments = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default Instruments;